import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Checkbox, Container, Panel, FieldSet, TextField, FormPanel, Button, Spacer, PasswordField, Label } from '@sencha/ext-modern'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'

import { doLogin, } from '../reducers/actions'
import colors from '../components/colors'
import Logo from './Logo'
import Supplier from './Supplier'

const panelProps = {
	height: "100%",
	margin: '0 0 40 0',
}

class Login extends React.Component {
	state = {
		logining: false,
		userName: '',
		password: '',
		errorMessage: null,
		passwordExpired: false
	}

	setFocus = () => {
		window.focus()
		this.refs.userName && this.refs.userName.cmp.focus()
	}

	componentDidMount() {
		// localStorage.autoLogin = true
		//   this.source = this.refs.dragItem && this.refs.dragContainer && new Ext.drag.Source({
		//     element: this.refs.dragItem.cmp.el,
		//     constrain: this.refs.dragContainer.cmp.el,
		//   }) || null

		// this.refs.dragItem && this.refs.dragItem.cmp.focus()
		this.setFocus()

	}

	componentWillUnmount() {
		this.source && Ext.destroy(this.source);
	}

	handleLogin = () => {
		const { doLogin, history } = this.props
		const { userName, password, logining } = this.state

		if (logining) return

		if (!userName || !password) {
			this.setState({ errorMessage: "用户名和密码不能为空！" })
			return
		}
		doLogin({
			userName, password,
			onRequest: () => {
				this.setState({ logining: true })
			},
			onEnd: ({ errorMessage, passwordExpired }) => {
				if (errorMessage) {
					this.setState({ logining: false, errorMessage, passwordExpired })
				} /* else {
          history.push('/')
        } */
			}
		})
	}

	handleInput = (obj, value) => {
		const name = obj.getName()
		this.setState({ [name]: value, errorMessage: null, })
	}

	handleEnterKey = (obj) => {
		const name = obj.getName()
		name === 'userName' && this.refs.password && this.refs.password.cmp.focus()
		name !== 'userName' && this.handleLogin()
	}

	handleBlur = (cmp) => {
		// Promise.resolve().then(() => {
		//   for (const ref of [this.refs.userName, this.refs.password, this.refs.autoLogin, this.refs.login])
		//     if (ref && ref.cmp.hasFocus) {
		//       return
		//     }

		//   cmp.focus()
		// })
	}

	render() {
		const { token } = this.props
		const { logining, errorMessage, passwordExpired, userName } = this.state

		return token
			? Tyan.loginRedirect()
			: passwordExpired
				? <Redirect to={`/ChangePasswordUnLogin/${userName}`} />
				: <Panel shadow layout="fit" {...panelProps}>
					<Container layout={{ type: 'hbox', align: 'top', pack: "center" }} style={colors.card.grey} padding={Ext.os.is.Phone ? "20% 0 0 0" : "150 0 0 0"} ref="dragContainer">
						<FormPanel shadow ref="dragItem">
							<Spacer height="10" />
							<Logo title="实验室信息管理系统4.0" />
							<Spacer height="10" />
							<FieldSet title="宜特（昆山）检测技术服务有限公司" width={Ext.os.is.Phone ? "280" : "320"}>
								<TextField label="用户名" /* disabled={autoLogin}  */ ref="userName" onBlur={this.handleBlur}
									name="userName"
									labelAlign="top"
									required
									placeholder="请输入用户名"
									requiredMessage="请输入用户名"
									onAction={this.handleEnterKey}
									onChange={this.handleInput} />
								<PasswordField label="密码" /* disabled={autoLogin}  */ ref="password" onBlur={this.handleBlur}
									name="password"
									labelAlign="top"
									required
									placeholder="请输入密码"
									requiredMessage="请输入密码"
									onAction={this.handleEnterKey}
									onChange={this.handleInput} />
							</FieldSet>
							{/* <Link to='/ForgetPassword' style={{ color: "#3a8df0", textDecoration: "none", textAlign: "right" }}>忘记密码?</Link> */}
							<Spacer height='10' />
							{errorMessage ? <Label html={errorMessage} style={{ color: 'red' }} margin='0 5 10 5' /> : <Spacer height="28" />}
							<Button ref="login" onBlur={this.handleBlur}
								ui="action raised"
								iconCls={logining && "x-fa fa-spinner fa-pulse" || "x-fa fa-user"}
								text="登录"
								width="100%"
								handler={this.handleLogin}
							/>
							<Spacer height="20" />
							{/* <Supplier /> */}
							<Spacer height="20" />
						</FormPanel>
					</Container>
				</Panel>
	}
}

const mapStateToProps = ({ loginInfo: { token } }) => ({
	token,
})

export default compose(
	connect(mapStateToProps, { doLogin }),
)(Login)
